import { render, staticRenderFns } from "./ByMnemonicContainer.vue?vue&type=template&id=ddee050a&scoped=true&"
import script from "./ByMnemonicContainer.vue?vue&type=script&lang=js&"
export * from "./ByMnemonicContainer.vue?vue&type=script&lang=js&"
import style0 from "./ByMnemonicContainer.vue?vue&type=style&index=0&id=ddee050a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddee050a",
  null
  
)

export default component.exports